import {Link} from 'react-router-dom';
type FeatureProps = {
  icon1?: string;
  icon2?: string;
  text1?: string;
  text2?: string;
  btn1?: string;
  btn2?: string;
  link1?: string;
  link2?: string;
};
function Features(props: FeatureProps) {
  return (
    <div className="ltn__feature-area section-bg-1 pt-60 pb-90">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-sm-6 col-12">
            <div className="ltn__feature-item ltn__feature-item-61 text-center bg-lemon  box-shadow-1">
              <div className="ltn__feature-info">
                <span>
                  <i className={`${props.icon1} ltn__feature-icon-2`}></i>{' '}
                </span>
                <p>{props.text1}</p>
              </div>
              <div className="btn-wrapper animated">
                <Link
                  to={`${props.link1}`}
                  className="theme-btn-1 btn btn-effect-1"
                >
                  {props.btn1}
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-sm-6 col-12">
            <div className="ltn__feature-item ltn__feature-item-61 text-center bg-lemon  box-shadow-1">
              <div className="ltn__feature-info">
                <span>
                  <i className={`${props.icon2} ltn__feature-icon-2`}></i>{' '}
                </span>
                <p>{props.text2}</p>
              </div>
              <div className="btn-wrapper animated">
                <Link
                  to={`${props.link2}`}
                  className="theme-btn-1 btn btn-effect-1"
                >
                  {props.btn2}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;
